import axios from "axios";

var baseDomain = "";

switch(document.location.host)
{
	case "www.scanandbook.co.uk":
		baseDomain = "https://api.scanandbook.co.uk/footfest";
		break;	
	case "www.scanandbook-preview.co.uk":
		baseDomain = "https://api.scanandbook-preview.co.uk";
		break;
	case "localhost:8081":
	case "localhost:8082":
		baseDomain = "http://localhost/footfest/public_html";
		break;
	default:
		console.warn(`Unknown host: ${document.location.host}. Using default API configuration.`);
		baseDomain = "https://api.scanandbook.co.uk/footfest";
		break;
}

const baseURL = `${baseDomain}/api`;

console.log(`API Configuration - Host: ${document.location.host}, Base URL: ${baseURL}`);

const repository = axios.create({
baseURL
});

// Add request interceptor for debugging
repository.interceptors.request.use(request => {
  console.log('Starting Request:', {
    url: request.url,
    baseURL: request.baseURL,
    fullURL: `${request.baseURL}/${request.url}`,
    method: request.method
  });
  return request;
});

// Add response interceptor for debugging
repository.interceptors.response.use(
  response => {
    console.log('Response Success:', {
      url: response.config.url,
      status: response.status,
      statusText: response.statusText,
      dataType: typeof response.data,
      dataLength: typeof response.data === 'string' ? response.data.length : 'N/A'
    });
    return response;
  },
  error => {
    console.error('Response Error:', {
      url: error.config?.url,
      status: error.response?.status,
      statusText: error.response?.statusText,
      message: error.message
    });
    return Promise.reject(error);
  }
);

export default repository;